import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Checks if a string is a valid UUID
 */
export function isUUID(value: string): boolean {
  const uuidRegex =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  return uuidRegex.test(value);
}

/**
 * Builds the initial Ask Stella prompt for Learning Modules
 * Intelligently handles punctuation to avoid double periods
 */
export function buildInitialAskStellaPrompt(moduleTitle: string): string {
  const basePrompt = `I'd like your help with ${moduleTitle}`;

  const endsWithPunctuation = /[.!?]$/.test(moduleTitle.trim());

  return endsWithPunctuation ? basePrompt : `${basePrompt}.`;
}
